import Chat from './chat';
import LineChart from './lineChart';
import MyAssets from './myAssets';

export default {
  EbChat: Chat,
  EbLineChart: LineChart,
  EbMyAssets: MyAssets,
}



// WEBPACK FOOTER //
// ./src/components/widgets/index.js